<template>
  <div class="drp">
    <v-toolbar color="white" height="58px" class="header">
      <v-select
        v-model="selects.grupo.value"
        :items="selects.grupo.items"
        dense
        label="Selecione o Grupo"
        outlined
        item-value="id"
        item-text="descricao"
        hide-details
        @change="buscarFiliais();desserts = [];"
      />

      <v-autocomplete
        v-model="selects.filial.value"
        :items="ITENS_SELECAO_FILIAIS"
        label="Selecione a Filial"
        item-text="descricao"
        item-value="filial"
        class="ml-4"
        hide-details
        height="10"
        outlined
        dense
        :multiple="multiplaSelecaoDeFiliais"
        small-chips
        @change="desserts = []"
        style="width: 200px"
      >
        <template #selection="data" v-if="multiplaSelecaoDeFiliais">
          <span>
            {{ data.item.filial }}
          </span>
          <span v-show="selects.filial.value.indexOf(data.item.filial) != selects.filial.value.length - 1">,&nbsp;</span>
        </template>

        <template #append v-if="multiplaSelecaoDeFiliais">
          <v-chip
            v-show="selects.filial.value.length >= 7"
            small
            outlined
            style="font-size: 12px; color: #444"
          >
            <span
              v-if="selects.filial.value.length === selects.filial.items.length"
            >
              Todas Selecionadas
            </span>
            <span v-else> {{ selects.filial.value.length }} selecionadas </span>
          </v-chip>
        </template>

        <template #prepend-item v-if="selects.filial.items.length && multiplaSelecaoDeFiliais">
          <v-list-item class="cursor-pointer py-2 px-lg-3" @click="selecinarTodasFiliais('filial')">
            <v-icon left :color="statusSelecionarTodasFiliais('filial').color">
              {{ "mdi-".concat(statusSelecionarTodasFiliais("filial").icon) }}
            </v-icon>
            {{ statusSelecionarTodasFiliais("filial").text }}
          </v-list-item>

          <v-divider />
        </template>
      </v-autocomplete>

      <v-select
        v-model="selects.status_abastecimento.value"
        :items="ITENS_SELECT_STATUS_ESTOQUE"
        dense
        label="Selecione o Status do Estoque"
        outlined
        hide-details
        item-value="status"
        item-text="name"
        v-if="selects.tipo_abastecimento.value > 0"
        class="ml-4"
        @change="selects.filial_origem.value = drpReversoSelecionado ? '' : [];desserts = [];"
      />

      <AjusteParamentros
        v-if="!OBJECT_FILIAL_SELECIONADA.hub"
        :items="selects.filial.items"
        :grupoDrp="selects.grupo.value"
        :filialSelecionada="filiaisSelecionadasForceArray"
        :drpReversoSelecionado="drpReversoSelecionado"
        @atualizar-parametros="() => buscarFiliais(false)"
      />

      <v-btn
        :disabled="!DISABLE_BUTTONS_COMPUTED"
        color="primary"
        class="ml-4"
        @click="buscarDrp()"
      >
        Buscar
      </v-btn>
    </v-toolbar>

    <sys-data-table
      v-model="linhas_selecionadas"
      :headers="HEADERS_COMPUTED"
      :items="produtos_filtrados_apartir_do_dessert"
      :search="search"
      show-select
      loading-text="Carregando... Aguarde"
      item-key="index_of"
      :height="alturaDaJanela - 310"
      :item-height="45"
      :item-class="classesCssItemDataTable"
      class="color-text-data-table"
      @contextmenu:row="menuContextoRow"
    >
      <template #top>
        <v-toolbar flat color="white" height="60px">
          <p class="subtitle-1 mr-4 mt-4" style="white-space: nowrap">
            Lista de Itens
            <span v-if="pedido.idpedido > 0">#{{ pedido.idpedido }}</span>
          </p>

          <v-divider inset vertical />

          <v-spacer />

          <div class="w-400 mr-5">
            <v-text-field
              v-model="search"
              label="Pesquisar"
              hide-details
              dense
              clearable
              append-icon="mdi-magnify"
              class="ml-4"
              v-lazy-input:debounce="1500"
            />
          </div>

          <FiltroAtivoInativo v-model="status_produto_selecionado" />

          <ExportarListaDeItensSeparacaoDeMercadoria
            v-if="produtos_filtrados_apartir_do_dessert.length > 0"
            :cabecalhos="headers"
            :parametros_utilizados_nos_filtros="parametros_utilizados_nos_filtros"
          />

          <FiltrosUniversalAvancado
            content-class="ml-4"
            ocultar_filtros_fixos
            ocultar_filtro_combinados
            @limpar:filtros="limparFiltrosFilial()"
            @update:filtros="buscarDrp()"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                :color="!DISABLE_BUTTONS_COMPUTED ? '#CCC' : '#1976D2'"
                :dark="DISABLE_BUTTONS_COMPUTED"
                class="ml-4"
                small
                v-bind="attrs"
                v-on="on"
                :disabled="!DISABLE_BUTTONS_COMPUTED"
              >
                <v-icon color="#FFFFFF" size="18">mdi-filter</v-icon>
                <span class="ml-1">Filtrar Escopo</span>
              </v-btn>
            </template>
          </FiltrosUniversalAvancado>

          <separacao-automatica
            :itensFull="desserts"
            :filiais="filiaisParaSeparacaoAutomatica"
            :departamentosSelecionados="selects.departamentos.values"
            :fornecedoresSelecionados="selects.fornecedores.value"
            :grupo="selects.grupo.value"
            :filial="filiaisSelecionadasForceArray"
            :tipoAbastecimento="selects.tipo_abastecimento.value"
            :statusAbastecimento="selects.status_abastecimento.value"
            :pedido="pedido"
            :configuracaoDRP="configuracaoDRP"
            @separado-automaticamente="produtosSeparadosAutomaticamente"
            @produtos-separados="buscarDrp()"
          />

          <CarrinhoSeparacao
            :atualizar_pedidos_carrinho_count="atualizar_pedidos_carrinho_count"
            :configuracaoDRP="configuracaoDRP"
            :idgrupo="selects.grupo.value"
            :selects="selects"
            @update:status-pedido="getStatusPedido"
            @update:exportacao-protheus="ev => pedidoExportadoParaProtheus(ev)"
            @update:atualizacao-pedido="$emit('atualizarPedido', (atualizar += 1))"
            @update:listagem-produtos="buscarDrp"
          />

<!--          <v-badge v-if="pedido.total_itens > 0" color="white" overlap class="ml-4">-->
<!--            <template #badge>-->
<!--              <span style="color: #000">{{ pedido.total_itens }}</span>-->
<!--            </template>-->

<!--            <v-btn color="#A51B32" small dark @click="buscarPedido(pedido.idpedido)">-->
<!--              <v-icon left>mdi-truck</v-icon>-->
<!--              Carrinho-->
<!--            </v-btn>-->
<!--          </v-badge>-->
        </v-toolbar>
      </template>

      <template #header.estoque_disponivel>
        <span v-if="drpReversoSelecionado">Estoque Disp. Filial</span>
        <span v-else>Estoque Disp. Grupo</span>
      </template>

      <template #header.action="{text}">
        <div v-text="text" class="text-center" />
      </template>

      <template #item.idproduto="{item}">
        <div class="d-flex align-center">
          <span>{{ item.idproduto }}</span>

          <v-spacer />

          <DetalhesProdutoDrp
            :idgrupo="selects.grupo.value"
            :filial_destino="item.filial"
            :idproduto="item.idproduto"
            :status_abastecimento="selects.status_abastecimento.value"
          />
        </div>
      </template>

      <template #item.filial="{item}">
        <template v-if="OBJECT_FILIAL_SELECIONADA && OBJECT_FILIAL_SELECIONADA.hub">
          {{ OBJECT_FILIAL_SELECIONADA.descricao }}
        </template>

        <template v-else>
          {{ item.filial }}
        </template>
      </template>

      <template #item.icon="{item}">
        <v-icon v-if="item.qtde_pendente > 0" small v-text="'mdi-truck'" />
      </template>

      <template #item.razao_social="{item}">
        {{`${item.idfornecedor} - ${item.razao_social}`}}
      </template>

      <template #item.consumo_medio_mensal="{item}">
        {{Helpers.formatarValor(item.consumo_medio_mensal)}}
      </template>

      <template #item.estoque="{item}">
        {{Helpers.formatarValor(item.estoque)}}
      </template>

      <template #item.saldo_necessidade_drp_embalagem="{item}">
          {{ Helpers.formatarValor(item.saldo_necessidade_drp / item.multiplo_dist) }}
      </template>/

      <template #item.saldo_necessidade_drp="{item}">
        <span v-if="drpReversoSelecionado" v-text="'0'" />
        <span v-else v-text="Helpers.formatarValor(item.saldo_necessidade_drp)" />
      </template>

      <template #item.estoque_disp_distribuicao="{item}">
        <span v-text="Helpers.formatarValor(item.estoque_disp_distribuicao)" />
      </template>

      <template #item.estoque_disponivel="{item}">
        <span v-text="Helpers.formatarValor(item.estoque_disponivel)" />
      </template>

      <template #item.estoque_transito_drp="{item}">
        <span>{{ Helpers.formatarValor(item.estoque_transito_drp) }}</span>
      </template>

      <template #item.qtde_pendente="{item}">
        <div class="d-flex align-center">
          <span>{{ Helpers.formatarValor(item.qtde_pendente) }}</span>

          <v-btn
            v-if="Number(item.qtde_pendente) > 0"
            icon small class="ml-n1"
            @click="DetalhamentoCompras(item.idproduto, item.idfornecedor, item.razao_social);"
          >
            <v-icon :size="16">mdi-information-outline</v-icon>
          </v-btn>
        </div>
      </template>

      <template #item.data_cadastro="{item}">
        <span v-text="formatarData(item.data_cadastro)" />
      </template>

      <template #item.action="{item}">
        <div class="d-flex align-center">
          <ConfigDistribuicaoProdutoDialog
            v-if="!OBJECT_FILIAL_SELECIONADA.hub"
            :produto="item"
            :active="item.config_distribuicao_produto"
            @update:active="item.config_distribuicao_produto = $event"
            @atualizar-lista-produtos="buscarDrp()"
          />

          <v-btn v-if="drpReversoSelecionado" icon @click="produtoSelecionado = item;dialogAbastecimentoCD = true;">
            <v-icon>mdi-forklift</v-icon>
          </v-btn>

          <v-btn v-else icon @click="produtoSelecionado = item;dialog_filiais_com_estoque_disponivel = true">
            <v-icon>mdi-forklift</v-icon>
          </v-btn>
        </div>
      </template>

      <template #footer="{countItems}">
        <div class="d-flex align-center w-full px-2">
          <v-spacer />

          <div class="quadrado-15 bg-red" />
          <span class="font-12 ml-1">Produto Fora de linha</span>

          <v-divider vertical class="mx-3 my-1" />

          <span class="font-12 text-gray-800 py-2 pr-3">{{ `Total de Itens: ${Helpers.formatarValor(countItems)}` }}</span>
        </div>
      </template>
    </sys-data-table>

    <!-- Dialog com as filiais com estoque disponivel para transferencia reversa -->
    <dialog-separacao
      v-model="dialogAbastecimentoCD"
      :produto="produtoSelecionado"
      :filiais="COMPUTED_FILIAIS_DRP_REVERSO"
      :pedido="pedido"
      @produto-add-com-sucesso="buscarDrp();$emit('atualizar-pedido', (atualizar += 1));"
    />

    <!-- Dialog com as filiais com estoque disponivel para transferencia -->
    <FiliaisComEstoqueDisponivelParaTransferencia
      v-model="dialog_filiais_com_estoque_disponivel"
      :pedido_carrinho="pedido"
      :configuracaoDRP="configuracaoDRP"
      :produto_filial_destino="{...produtoSelecionado, grupo: selects.grupo.value}"
      @update:produto-add-carrinho="buscarDrp();atualizar++;$emit('atualizarPedido', atualizar);"
      @abrir-carrinho-transferencia="buscarPedido(pedido.idpedido)"
    />

    <!--Dialog tipo de relatorio-->
    <v-dialog v-model="dialogTipoRelatorio" max-width="450px" content-class="bra-20">
      <v-card>
        <v-card-title>
          <span>Tipo do relatório</span>

          <v-spacer />

          <v-btn icon @click="pedido = {};buscarDrp();dialogTipoRelatorio = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-select
            v-model="selects.tipoRelatorio.id"
            :items="selects.tipoRelatorio"
            label="Selecione Tipo Relatório"
            outlined
            item-value="id"
            item-text="tipo"
            hide-details
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn v-if="fn" color="primary" text @click="execReportSeparacao(true, selects.tipoRelatorio.id)">Gerar</v-btn>
          <v-btn v-else color="primary" text @click="execReportSemSaldo(selects.tipoRelatorio.id)">Gerar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog pedido -->
    <v-dialog
      v-model="dialogPedido"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#042333" height="56px">
          <v-btn icon dark @click="fecharModalPedido()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-flex xs4>
            <div class="pl-1">
              <div class="d-flex align-center">
                <v-icon color="#FFF">mdi-cart</v-icon>
                <p class="ma-0 ml-1 font-weight-medium font-20">Carrinho de Separação</p>
              </div>

              <p class="ma-0 mt-n1 font-12">Pedido {{ pedido.idpedido }} aberto em {{ pedido.data_emissao }}</p>
            </div>
          </v-flex>

          <v-spacer />

          <v-flex xs2 class="ta-right">
            <p class="ma-0 font-16">
              <strong>Total Qtde: </strong>
              <span>{{ COMPUTED_TOTAL_QTDE }}</span>
            </p>

            <p class="ma-0 mt-n1 font-16">
              <strong>Total Peso: </strong>
              <span>{{ COMPUTED_TOTAL_PESO }}</span>
            </p>
          </v-flex>
        </v-toolbar>
        <sys-data-table
          v-model="pedidosSelecionados"
          :headers="headers_pedido"
          :items="desserts_pedido"
          item-key="idaux"
          show-select
          :search="searchCarrinho"
          :height="alturaDaJanela - 160"
          :item-height="40"
          :item-class="item => ({'text-red': Number(item.qtde_inicial) !== Number(item.qtde_pedido), 'text-dark-green': item.produto_novo })"
        >
          <template #top>
            <v-toolbar flat color="white" class="ma-0 pa-0">
              <h4 class="ml-n3">
                <v-icon left>mdi-format-list-bulleted-square</v-icon>
                Lista de Produtos
              </h4>

              <v-btn
                v-if="pedidosSelecionados.length"
                color="red"
                class="ml-6"
                @click="delMultPedido()"
                dark
                small
              >
                <v-icon left small>mdi-delete</v-icon>
                Remover ({{ pedidosSelecionados.length }})
              </v-btn>

              <v-spacer />

              <v-text-field
                v-model="searchCarrinho"
                label="Pesquisar"
                class="mt-6 mr-6"
                clearable
                append-icon="mdi-magnify"
                style="max-width: 450px"
              />

              <v-btn
                color="primary"
                small
                class="mr-5"
                @click="execReportSeparacao(true, 2)"
              >
                <v-icon left>mdi-file-excel</v-icon>
                Relatório Excel
              </v-btn>

              <ExportacaoPedidoNerus :pedido="pedido" @pedido-exportado="dialogPedido = false; getStatusPedido();" />

              <ExportacaoPedidoApiAcal :pedido="pedido" @pedido-exportado="dialogPedido = false; getStatusPedido();" />

              <ExportacaoNativaWinthor
                v-if="configuracaoDRP.drp_exportacao_nativa_winthor"
                :idpedido_systock="Number(pedido.idpedido)"
                content_class="mr-5"
                :apenas_uma_origem_e_um_destino="pedido.filiais_origem && pedido.filiais_origem.length === 1 && pedido.filiais_destino.length === 1"
                @exportado-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPadreCicero
                v-if="configuracaoDRP.exportacao_drp_padre_cicero"
                content_class="mr-5"
                :idpedido_systock="Number(pedido.idpedido)"
                @exportado-com-sucesso="dialogPedido = false; getStatusPedido();"
              />

              <ExportacaoPedidoDrpParaErpWinthor
                v-if="configuracaoDRP.exportacao_winthor_drp === 'S'"
                :pedido="pedido"
                content_class="mr-5"
                @exportacao-realizada-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPedidoCisspoderIntegrim
                v-if="configuracaoDRP.integracao_exportacao_cisspoder_integrim"
                :idpedido_systock="Number(pedido.idpedido)"
                content_class="mr-5"
                @exportado-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <ExportacaoPedidoAutomatiza
                v-if="configuracaoDRP.exportacao_automatiza"
                :pedido="pedido"
                content_class="mr-5"
                @pedido-exportado="pedidoExportadoParaProtheus($event)"
              />

              <ExportacaoPedidoCasaTudoSacolao
                v-if="configuracaoDRP.exportacao_casa_tudo_sacolao"
                :idpedido_systock="Number(pedido.idpedido)"
                content_class="mr-5"
                @exportado-com-sucesso="dialogPedido = false;getStatusPedido();"
              />

              <incluir-pedido-loja-drp
                v-if="configuracaoDRP.exportacao_protheus_drp === 'S'"
                :pedido="pedido"
                @pedido-exportado="pedidoExportadoParaProtheus($event)"
              />

              <v-btn v-else color="primary" @click="finalizar()" small>
                <h4 style="color: #fff">Finalizar</h4>
              </v-btn>
            </v-toolbar>
          </template>

          <template #header>
            <tr>
              <td :colspan="10" />
              <td :colspan="4" style="border: 1px solid #e1dfdf" class="text-center font-14 font-weight-medium pt-1 text-gray-800 border-b-none">Origem</td>
              <td :colspan="5" style="border: 1px solid #e1dfdf" class="text-center font-14 font-weight-medium pt-1 text-gray-800 border-l-none border-b-none">Destino</td>
            </tr>
          </template>

          <template #item.filial_origem="{item}">
            {{ item.filial_origem }}
          </template>

          <template #item.nome_fornecedor="{ item }">
            <p
              class="text-no-wrap ma-0 text-truncate w-100"
              :title="`${item.idfornecedor} - ${item.razao_social}`"
            >
              {{ item.razao_social }}
            </p>
          </template>

          <template #item.peso="{ item }">
            {{ Helpers.formatarValorComCasas(item.peso * item.qtde_pedido) }}
          </template>

          <template #item.filial_destino="{item}">
            {{ item.descricao_hub ? item.descricao_hub : item.filial_destino }}
          </template>

          <template #item.classificacao_popularidade="{item}">
            <span v-if="item.classificacao_popularidade === 'P'">1. Frequência Alta de Saída</span>
            <span v-else-if="item.classificacao_popularidade === 'Q'">2. Frequência Média de Saída</span>
            <span v-else>3. Frequência Baixa de Saída</span>
          </template>

          <template #item.descricao_produto="{item}">
            <div class="d-flex align-center ml-n2">
              <DetalhesProdutoDrp
                :idgrupo="selects.grupo.value"
                :filial_destino="item.filial_destino"
                :filial_origem="item.filial_origem"
                :idproduto="item.idproduto"
                :status_abastecimento="item.filial_destino_eh_cd ? 'DISP DRP' : 'DRP'"
              />

              {{ item.descricao_produto }}
            </div>
          </template>

          <template #item.qtde_pedido_embalagem="{item}">
            <div class="d-flex align-center">
              {{ Helpers.formatarValor(item.qtde_pedido / item.multiplo_dist) }}
            </div>
          </template>

          <template #item.qtde_pedido="props" style="cursor: pointer">
            <TextFieldFormatadorDeValor
              v-if="props.item.drp_ativar_edicao_qtde_carrinho"
              v-model="props.item.qtde_pedido"
              hide-details
              dense
              class="text-field-centralizado font-12 w-80 pb-2"
              :maxDigitos="0"
              @focus="ev => ev.target.select()"
              @keypress.enter="alterarQuantidadeDaLinha(props.item)"
              @blur="alterarQuantidadeDaLinha(props.item)"
            />

            <span v-else>{{ Helpers.formatarValor(props.item.qtde_pedido) }}</span>
          </template>

          <template #item.action="{item}">
            <v-btn icon @click="delItemPedido(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>

          <template #footer.prepend>
            <div class="d-flex align-center ml-3">
              <div class="quadrado-15 bg-green"></div>
              <span class="ml-1 font-13">Produto Novo</span>
            </div>
          </template>
        </sys-data-table>
      </v-card>
    </v-dialog>

    <!-- Modal ultimas compras -->
    <v-dialog v-model="dialogUltimasCompras" persistent max-width="1000" content-class="bra-20">
      <v-card>
        <v-card-title>
          <span class="font-18">Últimas compras do fornecedor {{ Helpers.primeiraLetraMaiuscula(razao_social) }}</span>

          <v-spacer />

          <v-btn icon @click="dialogUltimasCompras = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headersTabelaUltimas"
            :items="ultimasCompras"
            fixed-header
            hide-default-footer
            class="font-resp-tabela"
            height="calc(100vh - 300px)"
            :items-per-page="-1"
          >
            <template #item.qtde="{item}">
              {{ Helpers.formatarValor(item.qtde) }}
            </template>

            <template #item.qtde_pendente="{item}">
              {{ Helpers.formatarValor(item.qtde_pendente) }}
            </template>

            <template #item.pcompra="{item}">
              {{ Helpers.formatarValorMonetario(item.punit) }}
            </template>

            <template #item.total_compra="{item}">
              {{ Helpers.formatarValorMonetario(item.total_compra) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-menu
      v-model="menu.show"
      :position-x="menu.posicao_x_menu"
      :position-y="menu.posicao_y_menu"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item v-for="(item, index) in menu.itens" :key="index" dense v-show="item.show()" @click="item.func()">
          <v-icon left>{{ item.icon }}</v-icon>
          <span class="font-12">{{ item.title }}</span>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import DrpAPI from "../../../api/drp";
import AjusteParamentros from "./AjusteParametrosDialog";
import dialogSeparacao from "./abastecimentoFiliaisCD/dialogSeparacao";
import separacaoAutomatica from "./separacaoAutomatica/Index";
import IncluirPedidoLojaDrp from "./exportacaoProtheus/IncluirPedidoLojaDrp";
import $axios from './../../../api/api.js'
import ConfigDistribuicaoProdutoDialog from "./ConfigDistribuicaoProdutoDialog";
import Filtros from "./filtrosSeparacaoDeMercadorias/Index.vue"
import FiltroAtivoInativo from "./filtrosSeparacaoDeMercadorias/FiltroAtivoInativo.vue";
import ResponsiveHeight from "../../../helpers/ResponsiveHeight";
import {logout} from "@/helpers";
import {buscarHubsDistribuicao} from "@/api/drp/Hub";
import { salvarSilenciamentoProdutos, salvarSilenciamentoMultiplosProdutos } from '@/api/drp/blacklist.js'
import DetalhesProdutoDrp from "@/components/drp/separacaoDeMercadorias/DetalhesProduto/Index";
import FiliaisComEstoqueDisponivelParaTransferencia from "./FiliaisComEstoqueDisponivelParaTransferencia/Index.vue";
import ExportacaoPedidoDrpParaErpWinthor from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Winthor/Index";
import ExportacaoPadreCicero from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/PadreCicero/Index.vue";
import ExportacaoPedidoCisspoderIntegrim from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/CisspoderIntegrim/Index.vue";
import ExportacaoPedidoAutomatiza from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Automatiza/Index.vue";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import Api from '@/api/api';
import ExportacaoNativaWinthor from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/NativaWinthor/Index.vue";
import ExportacaoPedidoNerus from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Nerus/Index.vue";
import ExportacaoPedidoApiAcal from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Gemco/Index.vue";
import ExportacaoPedidoCasaTudoSacolao from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/CasaTudoSacolao/Index.vue";
import ExportarListaDeItensSeparacaoDeMercadoria from "./ExportarListaDeItensSeparacaoDeMercadoria.vue";
import CarrinhoSeparacao from "@/components/drp/separacaoDeMercadorias/Carrinho/Index.vue";
import FiltrosUniversalAvancado from "@/components/utils/FiltrosUniversalAvancado.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

export default {
  name: "Drp",
  mixins: [ResponsiveHeight],
  props: {
    atualizarCarrinho: [Number, String],
    configuracaoDRP: {
      type: Object,
      required: true
    }
  },
  components: {
    DivisorComLegenda,
    SysAutocomplete,
    SysFilialGrupoAutocomplete,
    FiltrosUniversalAvancado,
    FiliaisComEstoqueDisponivelParaTransferencia,
    DetalhesProdutoDrp,
    ConfigDistribuicaoProdutoDialog,
    AjusteParamentros,
    dialogSeparacao,
    separacaoAutomatica,
    IncluirPedidoLojaDrp,
    Filtros,
    FiltroAtivoInativo,
    ExportacaoPedidoDrpParaErpWinthor,
    ExportacaoPadreCicero,
    ExportacaoPedidoCisspoderIntegrim,
    ExportacaoPedidoAutomatiza,
    TextFieldFormatadorDeValor,
    ExportacaoNativaWinthor,
    ExportacaoPedidoApiAcal,
    ExportacaoPedidoNerus,
    ExportacaoPedidoCasaTudoSacolao,
    ExportarListaDeItensSeparacaoDeMercadoria,
    CarrinhoSeparacao,
},
  data() {
    return {
      loading: false,
      linhas_selecionadas: [],
      menu: {
        show: false,
        posicao_x_menu: 0,
        posicao_y_menu: 0,
        itens: [
          { title: 'Silenciar produto', icon: 'mdi-playlist-remove', func: () => this.filtrarProdutoDaLista(), show: () => this.linhas_selecionadas.length == 0 },
          { title: 'Silenciar produtos selecionados', icon: 'mdi-playlist-remove', func: () => this.filtrarMultiplosProdutoDaLista(), show: () => this.linhas_selecionadas.length > 0 },
        ],
        selecionado: {
          pesquisa: ''
        }
      },
      pedido: { idpedido: " " },
      pedidosSelecionados: [],
      produtoSelecionado: {},
      necessidade: 0,
      fn: false,
      idfilial: 0, //armazena o id da filial destino
      parametrizada: "",
      necessidadeTotal: 0,
      dialogPedido: false,
      dialog_filiais_com_estoque_disponivel: false,
      dialogTipoRelatorio: false,
      dialogUltimasCompras: false,
      grupo: "",
      search: "",
      atualizar: 0,
      ultimasCompras: [],
      razao_social: "",
      idfornecedor: "",
      fornecedoresSelecionados: [],
      estoque_origem: 0,
      selects: {
        exibir_produtos_nao_configurados: false,
        filial_origem: {
          items: [],
          value: [],
        },
        filial: {
          items: [],
          value: [],
        },
        grupo: {
          items: [],
          value: "",
        },
        tipo_abastecimento: {
          items: [{id: 2, name: "Cobertura de Estoque Parametrizada" }],
          value: 2,
        },
        status_abastecimento: {
          items: [
            {id: 1, name: "Adequado", status: "OK" },
            {id: 2, name: "Precisando de Abastecimento", status: "DRP"},
            {id: 3, name: "Disponível para Distribuição", status: "DISP DRP"},
            {id: 4, name: "Todos", status: " "},
          ],
          value: "",
        },
        fornecedores: {
          items: [],
          value: [],
        },
        departamentos: {
          values: [],
        },
        secao: {
          values: [],
        },
        categorias: {
          values: [],
        },
        tipoRelatorio: [
          { id: 1, tipo: "Relatório em PDF" },
          { id: 2, tipo: "Relatório em Excel" },
          { id: 3, tipo: "Relatório em CSV" },
        ],
      },
      headers: [
        { text: "", value: "icon", sortable: false },
        { text: "Filial", value: "filial" },
        { text: "Fornecedor", value: "razao_social" },
        { text: "Cod. Interno", value: "idproduto" },
        { text: "Cod. Fornecedor", value: "cod_produto" },
        { text: "Descrição Produto", value: "descricao_produto" },
        { text: "UM", value: "idunidade_medida" },
        { text: "Projeção de vendas", value: "consumo_medio_mensal" },
        { text: "Estoque", value: "estoque" },
        { text: "Necessidade DRP Embalagem", value: "saldo_necessidade_drp_embalagem" },
        { text: "Necessidade DRP", value: "saldo_necessidade_drp" },
        { text: "Estoque Disp. Filial", value: "estoque_disp_distribuicao" },
        { text: "Estoque Disp. Grupo", value: "estoque_disponivel" },
        { text: "Qtde. Trânsito", value: "qtde_pendente" },
        { text: "Total Transferencia", value: "estoque_transito_drp" },
        { text: "Data Prevista", value: "data_prevista" },
        { text: "Data Cadastro", value: "data_cadastro" },
        { text: "Ações", value: 'action', width: "120px" },
      ],
      desserts: [],
      headers_pedido: [
        { text: "Filial Origem", value: "filial_origem" },
        { text: "Filial Destino", value: "filial_destino" },
        { text: "Tipo Produto", value: "tipo_produto" },
        { text: "Cód. Produto", value: "idproduto" },
        { text: "Cód. Fabricante", value: "cod_produto" },
        // { text: "Frequência de Saída", value: "classificacao_popularidade" },
        { text: "Descrição Produto", value: "descricao_produto" },
        { text: "Fornecedor", value: "nome_fornecedor" },
        { text: "UN", value: "unidade_compra" },
        { text: "Peso", value: "peso" },
        // { text: "Qtde. Dias de Gatilho", value: "qtde_dias_gatilho" },
        // { text: "Data e Hora", value: "log_data" },

        { text: "Estoque", title: 'Saldo de Estoque', value: "origem_estoque", is_number: true, style: { borderLeft: '1px solid #e1dfdf'} },
        { text: "Proj. Vendas", title: 'Projeção de Vendas', value: "origem_projecao_venda", is_number: true },
        { text: "Est. Estético", title: 'Estoque Estético', value: "origem_estoque_min", is_number: true },
        { text: "Est. Máximo", title: 'Estoque Máximo', value: "origem_emax", is_number: true, style: { borderRight: '1px solid #e1dfdf'} },

        { text: "Estoque", title: 'Saldo Estoque', value: "destino_estoque", is_number: true },
        { text: "Disp. Trans.", title: 'Estoque Disponível para Transferência', value: "destino_estoque_disponivel", is_number: true },
        { text: "Proj. Vendas", title: 'Projeção de Vendas', value: "destino_projecao_venda", is_number: true },
        { text: "Est. Estético", title: 'Estoque Estético', value: "destino_estoque_min", is_number: true },
        { text: "Est. Máximo", title: 'Estoque Máximo', value: "destino_emax", is_number: true, style: { borderRight: '1px solid #e1dfdf'} },
        { text: "Qtde. Produtos Embalagem", title: 'Qtde. Produtos Embalagem', value: "qtde_pedido_embalagem" },
        { text: "Qtde. Produtos", title: 'Qtde. Produtos', value: "qtde_pedido" },

        { text: "Ações", value: "action" },
      ],
      desserts_pedido: [],
      headersTabelaUltimas: [
        { text: "Filial", value: "filial" },
        { text: "Pedido", value: "ordem_compra" },
        { text: "Solicitação", value: "data_solicitacao" },
        { text: "Previsão", value: "data_previsao" },
        { text: "Qtde.", value: "qtde" },
        { text: "Qtde. Pendente", value: "qtde_pendente" },
        { text: "Valor Unit.", value: "pcompra" },
        { text: "Total", value: "total_compra" },
      ],
      addok: [],
      selecionarTodosFornecedores: false,
      dialogAbastecimentoCD: false,
      searchCarrinho: "",
      showInputPesquisa: false,
      hubs: [],
      status_produto_selecionado: ['A'],
      produtos_filtrados_apartir_do_dessert: [],
      atualizar_pedidos_carrinho_count: 0,
      parametros_utilizados_nos_filtros: {},
      ignorar_filtros: [
        'tipos_produtos', 'venda_futura_maior_que_saldo_estoque', 'grupos',
        'fora_de_linha', 'inativo_revenda', 'produto_resgatado'
      ],
      filtros_filias: {
        filiais_origem: [],
        filiais_destino: []
      }
    };
  },
  created() {
    this.buscarGrupos();
    this.buscarHubs();
  },
  mounted() {
    this.filtrarProdutos();
  },
  computed: {
    HEADERS_COMPUTED() {
      const headers = Object.assign([],this.headers);

      if (this.drpReversoSelecionado) {
        return headers.filter(item => item.value !== 'estoque_disponivel');
      }

      return headers.filter(item => item.value !== 'estoque_disp_distribuicao');
    },
    COMPUTED_TOTAL_QTDE() {
      return this.Helpers.formatarValorComCasas(this.desserts_pedido.reduce((acumulador, itemAtual) => parseFloat(acumulador) + parseFloat(itemAtual.qtde_inicial), 0));
    },
    COMPUTED_TOTAL_PESO() {
      return this.Helpers.formatarValorComCasas(this.desserts_pedido.reduce((acumulador, itemAtual) => parseFloat(acumulador) + (parseFloat(itemAtual.qtde_pedido) * parseFloat(itemAtual.peso)), 0));
    },
    fornecedoresDrp() {
      let fornecedores = [];

      this.produtos_filtrados_apartir_do_dessert.forEach((item) => {
        const fornecedor = {
          idfornecedor: item.idfornecedor,
          razao_social: `${item.idfornecedor} - ${item.razao_social}`,
        };

        const existe = fornecedores.filter(
          (f) => f.idfornecedor == item.idfornecedor
        );

        if (existe.length === 0) {
          fornecedores.push(fornecedor);
        }
      });

      return fornecedores;
    },
    multiplaSelecaoDeFiliais() {
      return this.configuracaoDRP.drp_multipla_selecao_filiais === "S";
    },
    filiaisSelecionadasForceArray() {
      if (!this.multiplaSelecaoDeFiliais && !Array.isArray(this.selects.filial.value)) {
        return [this.selects.filial.value];
      }

      return this.selects.filial.value;
    },
    filialSelecionada() {
      return this.selects.filial.value.length === this.selects.filial.items.length ? [] : this.selects.filial.value;
    },
    OBJECT_FILIAL_SELECIONADA() {
      if (!this.filialSelecionada || Array.isArray(this.filialSelecionada)) {
        return {};
      }
      return this.ITENS_SELECAO_FILIAIS.find(item => item.filial === this.filialSelecionada)
    },
    drpReversoSelecionado() {
      return (this.selects.status_abastecimento.value || '') === "DISP DRP";
    },
    FILIAIS_ORIGENS_DAS_FILIAIS_DESTINO_SELECIONADAS() {
      const filiais_selecionadas_obj = this.ITENS_SELECAO_FILIAIS.filter(item => this.filiaisSelecionadasForceArray.includes(item.filial));
      const filiais_origens = this.Helpers.arrayColumn(filiais_selecionadas_obj, 'filiais_origem');

      if (filiais_origens.some(itens => itens.length === 0)) return [];
      return filiais_origens.flat();
    },
    filiaisParaSeparacaoAutomatica () {
      const retornar_todas_filiais = !this.filiaisSelecionadasForceArray
        || this.filiaisSelecionadasForceArray.length === 0
        || this.FILIAIS_ORIGENS_DAS_FILIAIS_DESTINO_SELECIONADAS.length === 0
        || this.selects.status_abastecimento.value === 'DISP DRP';

      if (retornar_todas_filiais) {
        return this.selects.filial.items;
      }

      return this.selects.filial.items.filter(item => this.FILIAIS_ORIGENS_DAS_FILIAIS_DESTINO_SELECIONADAS.includes(item.filial));
    },
    ITENS_SELECAO_FILIAIS() {
      if (this.hubs && this.hubs.length > 0) {
        return this.hubs.concat(this.selects.filial.items);
      }
      return this.selects.filial.items;
    },
    ITENS_SELECT_STATUS_ESTOQUE() {
      if (this.OBJECT_FILIAL_SELECIONADA && this.OBJECT_FILIAL_SELECIONADA.hub) {
        return this.selects.status_abastecimento.items.filter(item => item.status !== 'DISP DRP');
      }
      return this.selects.status_abastecimento.items;
    },
    DISABLE_BUTTONS_COMPUTED() {
      return (this.selects.status_abastecimento.value !== ''
        && this.filiaisSelecionadasForceArray.length > 0)
    },
    COMPUTED_FILIAIS_DRP_REVERSO() {
      const raw = localStorage.getItem("configuracao_drp");
      const configuracao = raw ? JSON.parse(raw) : {
        drp_selecionar_outras_filiais_distribuicao_reversa: false
      };

      if (configuracao.drp_selecionar_outras_filiais_distribuicao_reversa === true) {
        return this.selects.filial.items;
      }

      return this.selects.filial.items.filter((filial) => filial.filial_cd === 'S');
    }
  },
  watch: {
    status_produto_selecionado: 'filtrarProdutos',
    'selects.departamentos.values': 'filtrarProdutos',
    'selects.secao.values': 'filtrarProdutos',
    'selects.categorias.values': 'filtrarProdutos',
    'selects.fornecedores.value': 'filtrarProdutos',
    'selects.exibir_produtos_nao_configurados': 'filtrarProdutos',
    desserts: 'filtrarProdutos',
    atualizarCarrinho() {
      this.getStatusPedido();
      this.buscarDrp();
    },
    selecionarTodosFornecedores() {
      this.fornecedoresSelecionados = [];

      if (this.selecionarTodosFornecedores) {
        this.fornecedoresDrp.forEach((item) => {
          this.fornecedoresSelecionados.push(item.idfornecedor);
        });
      }
    },
    desserts_pedido() {
      this.getStatusPedido();
    }
  },
  methods: {
    formatarData(data) {
      if (!data) return '00/00/0000';
      return data.split("-").reverse().join("/");
    },
    filtrarProdutos() {
      let itens = Object.assign([], this.desserts);

      if (this.status_produto_selecionado && this.status_produto_selecionado.length > 0) {
        itens = itens.filter(item => this.status_produto_selecionado.includes(item.status));
      }

      if (this.selects.departamentos.values && this.selects.departamentos.values.length > 0) {
        itens = itens.filter(item => this.selects.departamentos.values.some(departamento => `${departamento.id_departamento}` === `${item.id_departamento}`));
      }

      if (this.selects.secao.values && this.selects.secao.values.length > 0) {
        itens = itens.filter(item => this.selects.secao.values.some(secao => `${secao.id_secao}` === `${item.id_secao}`));
      }

      if (this.selects.categorias.values && this.selects.categorias.values.length > 0) {
        itens = itens.filter(item => this.selects.categorias.values.some(categoria => `${categoria.id_categoria}` === `${item.id_categoria}`));
      }

      if (this.selects.fornecedores.value && this.selects.fornecedores.value.length > 0) {
        itens = itens.filter(item => this.selects.fornecedores.value.some(fornecedor => `${fornecedor.id_fornecedor}` === `${item.idfornecedor}`));
      }

      if (this.selects.exibir_produtos_nao_configurados) {
        itens = itens.filter(item => item.config_distribuicao_produto != true);
      }

      this.produtos_filtrados_apartir_do_dessert = itens;
    },
    testeFiltros(tipo, evento) {
      switch (tipo) {
        case 'departamentos':
          this.selects.departamentos.values = evento;
          break;

        case 'secao':
          this.selects.secao.values = evento;
          break;

        case 'categorias':
          this.selects.categorias.values = evento;
          break;

        case 'fornecedores':
          this.selects.fornecedores.value = evento;
          break;
      }
    },
    alterarQuantidadeDaLinha(linha) {
      const parametros = {
        idpedido: linha.idpedido,
        idproduto: linha.idproduto,
        filial_origem: linha.filial_origem,
        filial_destino: linha.filial_destino,
        qtde_pedido: linha.qtde_pedido
      }

      Api.post('drp-grupo/atualizar-qtde-carrinho-separacao-mercadoria', parametros)
        .catch(logout);
    },
    menuContextoRow(e) {
      e.evento_padrao.preventDefault();
      this.menu.selecionado = {};
      this.menu.show = false;
      this.menu.posicao_x_menu = e.evento_padrao.clientX;
      this.menu.posicao_y_menu = e.evento_padrao.clientY;
      this.$nextTick(() => {
        this.menu.show = true;
        this.menu.selecionado = {
          grupo: this.selects.grupo.value,
          filial: [e.row.filial],
          pesquisa: [e.row.idproduto],
          tipo: 1
        }
      })
    },
    filtrarProdutoDaLista() {
      this.desserts = [];
      this.loading = true;

      this.$store.dispatch(
        'loading/addRequisicao',
        salvarSilenciamentoProdutos(this.menu.selecionado)
          .then(() => {
            this.buscarDrp();
            this.$emit("update:produtos-silenciados", {});
            this.loading = false;
          })
          .catch(logout)
      );
    },
    filtrarMultiplosProdutoDaLista() {
      this.desserts = [];
      this.loading = true;

      const parametros = this.linhas_selecionadas.map(i => ({ filial: i.filial, idproduto: i.idproduto }));

      this.$store.dispatch(
        'loading/addRequisicao',
        salvarSilenciamentoMultiplosProdutos(parametros)
          .then(() => {
            this.linhas_selecionadas = [];
            this.buscarDrp();
            this.$emit("update:produtos-silenciados", {});
            this.loading = false;
          })
          .catch(logout)
      );
    },
    pedidoExportadoParaProtheus(execRelatorio) {
      this.desserts_pedido = [];
      this.dialogPedido = false;
      this.dialog_filiais_com_estoque_disponivel = false;

      if (execRelatorio) {
        this.execReportSeparacao(false, 0);
      } else {
        this.buscarDrp();
      }

      this.$emit("atualizarPedido", (this.atualizar += 1));
    },
    pedidoExportadoParaNerus(execRelatorio) {
      this.desserts_pedido = [];
      this.dialogPedido = false;
      this.dialog_filiais_com_estoque_disponivel = false;

      if (execRelatorio) {
        this.execReportSeparacao(false, 0);
      } else {
        this.buscarDrp();
      }

      this.$emit("atualizarPedido", (this.atualizar += 1));
    },
    produtosSeparadosAutomaticamente() {
      this.getStatusPedido();
      this.buscarDrp();
      this.fornecedoresSelecionados = [];
      this.selecionarTodosFornecedores = false;
      this.$emit("atualizarPedido", (this.atualizar += 1));
    },
    statusSelecionarTodasFiliais(itemSelect) {
      let status = {};

      if (
        this.selects[itemSelect].items.length ===
        this.selects[itemSelect].value.length
      ) {
        status = {
          icon: "checkbox-marked",
          text: "Desmarcar Todos",
          color: "primary",
        };
      } else if (this.selects[itemSelect].value.length > 0) {
        status = {
          icon: "minus-box",
          text: "Selecionar Todos",
          color: "primary",
        };
      } else {
        status = {
          icon: "checkbox-blank-outline",
          text: "Selecionar Todos",
          color: "",
        };
      }

      return status;
    },
    selecinarTodasFiliais(itemSelect) {
      if (
        this.selects[itemSelect].items.length ===
        this.selects[itemSelect].value.length
      ) {
        this.selects[itemSelect].value = [];
      } else {
        this.selects[itemSelect].value = this.Helpers.arrayColumn(
          this.selects[itemSelect].items,
          "filial"
        );
      }
    },

    DetalhamentoCompras(idproduto, idfornecedor, razao_social) {
      this.dialogUltimasCompras = true;
      this.ultimasCompras = [];

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        idproduto: idproduto,
        idfornecedor: idfornecedor,
        grupo: this.selects.grupo.value,
      };

      this.razao_social = razao_social;

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getUltimasComprasFornecedorGrupo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.ultimasCompras = response.data.ultimasCompras;
          })
          .catch(logout)
      );
    },

    finalizar() {
      if (confirm("Deseja finalizar o Carrinho?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const iduser = localStorage.getItem("id");

        const params = {
          iduser: iduser,
          pedido: this.pedido.idpedido,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.finalizar(headers, params)
            .then((response) => {
              const token = response.data.token;

              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.dialogPedido = false;
                this.dialog_filiais_com_estoque_disponivel = false;

                this.execReportSeparacao(false, 0);
                this.$emit("atualizarPedido", (this.atualizar += 1));
              }
            })
            .catch(logout)
        );
      }
    },

    delMultPedido() {
      if (confirm("Deseja remover o Pedido?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = [];

        this.pedidosSelecionados.forEach((p) => {
          params.push({
            pedido: this.pedido.idpedido,
            filial_origem: p.filial_origem,
            filial_destino: p.filial_destino,
            produto: p.idproduto,
          });
        });

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.delMultPedido(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.pedidosSelecionados = [];
                this.buscarPedido(this.pedido.idpedido);
                this.$emit("atualizarPedido", (this.atualizar += 1));
              }
            })
            .catch(logout)
        );
      }
    },

    delItemPedido(pedido) {
      if (confirm("Deseja remover o Pedido?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          pedido: this.pedido.idpedido,
          filial_origem: pedido.filial_origem,
          filial_destino: pedido.filial_destino,
          produto: pedido.idproduto,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.delItemPedido(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.buscarPedido(this.pedido.idpedido);
                this.$emit("atualizarPedido", (this.atualizar += 1));
              }
            })
            .catch(logout)
        );
      }
    },

    buscarPedido(idpedido) {
      this.dialogPedido = true;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        pedido: idpedido,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getPedido(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.data.pedido == 0) {
              this.dialogPedido = false;
              this.buscarDrp();
            } else {
              this.desserts_pedido = response.data.pedido;
            }
          })
          .catch(logout)
      );
    },

    fecharModalPedido() {
      this.dialogPedido = false;
      this.buscarDrp();
    },
    getStatusPedido() {
      this.atualizar_pedidos_carrinho_count++;
    },
    buscarDrp() {
      this.atualizar_pedidos_carrinho_count++;
      this.loading = true;
      this.desserts = [];

      if (
        this.selects.status_abastecimento.value != "" &&
        this.filiaisSelecionadasForceArray.length > 0
      ) {
        if (this.selects.tipo_abastecimento.value === 1) {
          const headers = this.Helpers.iniciarRequisicao();

          const iduser = localStorage.getItem("id");

          const filtros_drp =
            Object.fromEntries(
              Object.entries(this.$store.getters["filtrosUniversalAvancado/filtros"])
                .filter(([f]) => !this.ignorar_filtros.includes(f)));

          const params = {
            iduser: iduser,
            filial: this.filialSelecionada,
            status: this.selects.status_abastecimento.value,
            grupo: this.selects.grupo.value,
            fornecedor: this.selects.fornecedores.value,
            ...filtros_drp,
            filiais_origem: this.filtros_filias.filiais_origem,
            filiais_destino: this.filtros_filias.filiais_destino,
            conconsiderar_produtos_combinacao: true,
          };

          this.parametros_utilizados_nos_filtros = {
            ...this.parametros_utilizados_nos_filtros,
            ...filtros_drp,
          };

          this.$store.dispatch(
            "loading/addRequisicao",
            DrpAPI.getDrpAutomatico(headers, params)
              .then((response) => {
                const token = response.data.token;
                localStorage.setItem("token", token);

                this.desserts = response.data.drp.map((item, index) => {
                  item.index = index;
                  return item;
                });

                this.loading = false;
              })
              .catch(logout)
          );
        } else {
          const headers = this.Helpers.iniciarRequisicao();

          if (this.selects.status_abastecimento.value == "DISP DRP") {
            this.parametros_utilizados_nos_filtros.filial = this.filiaisSelecionadasForceArray;
            this.parametros_utilizados_nos_filtros.grupo = this.selects.grupo.value;
            this.parametros_utilizados_nos_filtros.status = this.selects.status_abastecimento.value;
            this.parametros_utilizados_nos_filtros.est_disp = "S";
          } else {
            this.parametros_utilizados_nos_filtros.filial = this.filiaisSelecionadasForceArray;
            this.parametros_utilizados_nos_filtros.grupo = this.selects.grupo.value;
            this.parametros_utilizados_nos_filtros.status = this.selects.status_abastecimento.value;
            this.parametros_utilizados_nos_filtros.est_disp = "";
          }

          const filtros_drp =
            Object.fromEntries(
              Object.entries(this.$store.getters["filtrosUniversalAvancado/filtros"])
                .filter(([f]) => !this.ignorar_filtros.includes(f)));

          this.parametros_utilizados_nos_filtros = {
            ...this.parametros_utilizados_nos_filtros,
            ...filtros_drp,
          };

          this.$store.dispatch(
            "loading/addRequisicao",
            DrpAPI.getDrpParametrizado(headers, {
              ...this.parametros_utilizados_nos_filtros,
              ...filtros_drp,
              filiais_origem: this.filtros_filias.filiais_origem,
              filiais_destino: this.filtros_filias.filiais_destino,
              conconsiderar_produtos_combinacao: true
            })
              .then((response) => {
                const { token, drp } = response.data;
                localStorage.setItem("token", token);
                this.desserts = drp;
                this.loading = false;
              })
              .catch(logout)
          );
        }

        this.getStatusPedido();
      }
    },
    buscarGrupos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getGruposDrp(headers, {ativar_drp: 'S'})
          .then((response) => {
            const {token, grupos} = response.data;
            localStorage.setItem("token", token);
            this.selects.grupo.items = grupos;

            if (grupos.length === 1) {
              this.selects.grupo.value = grupos[0].id;
              this.buscarFiliais();
            }
          })
          .catch(logout)
      );
    },

    buscarFiliais(mudarSelecionado = true) {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.selects.grupo.value,
        disponibilidadeDrp: true,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getFiliaisDrp(headers, params)
          .then((response) => {
            const { token, filiais } = response.data;
            localStorage.setItem("token", token);

            this.selects.filial.items = [];

            filiais.forEach((item, index) => {
              item.id = index;

              if (item.nome_fantasia) {
                item.descricao += ` - ${item.nome_fantasia}`;
              }

              this.selects.filial.items.push(item);
            });

            this.desserts = [];
            mudarSelecionado && (this.selects.filial.value = []);
          })
          .catch(logout)
      );
    },
    execReportSemSaldo(tipo) {
      if (tipo === 1) {
        const token = localStorage.getItem("token");

        let url =
          "relatorio_romaneio_drp_sem_saldo?systock=grupo&token=" +
          token +
          "&filial=" +
          this.filiaisSelecionadasForceArray +
          "&grupo=" +
          this.selects.grupo.value +
          "&tipo=" +
          this.selects.tipo_abastecimento.value;

        window.open($axios.defaults.baseURL + "/" + url, "_blank");

        this.buscarDrp();
      } else {
        const token = localStorage.getItem("token");

        let url =
          "relatorio_romaneio_drp_sem_saldo_excel?systock=grupo&token=" +
          token +
          "&filial=" +
          this.filiaisSelecionadasForceArray +
          "&grupo=" +
          this.selects.grupo.value +
          "&tipo=" +
          this.selects.tipo_abastecimento.value;

        window.open($axios.defaults.baseURL + "/" + url, "_blank");
      }

      this.dialogTipoRelatorio = false;
    },
    execReportSeparacao(ok, tipo) {
      if (ok) {
        const token = localStorage.getItem("token");
        const usuario = localStorage.getItem("nome");

        const getRotaRelatorio = (tipo) => {
          const urls = [
            { tipo: 1, url: "relatorio_romaneio_drp2" },
            { tipo: 2, url: "relatorio_romaneio_drp2_excel" },
            { tipo: 3, url: "relatorio_romaneio_drp2_csv" },
          ];

          const respota = urls.filter((item) => item.tipo === tipo);

          return respota[0] ? respota[0].url : null;
        };

        const url = getRotaRelatorio(tipo).concat(
          "?systock=grupo&",
          `token=${token}&`,
          `pedido=${this.pedido.idpedido}&`,
          `usuario=${usuario}`
        );

        window.open($axios.defaults.baseURL + "/" + url, "_blank");

        this.pedido.idpedido = "";
        this.pedido.total_itens = 0;
        this.dialogTipoRelatorio = false;
        this.selects.tipoRelatorio.id = "";
        this.buscarDrp();
      } else {
        this.dialogTipoRelatorio = true;
        this.fn = true;
      }
    },
    buscarHubs() {
      this.$store.dispatch("loading/addRequisicao",
        buscarHubsDistribuicao()
          .then(hubs => {
            const callback = hub => {
              hub.hub = true;
              return hub;
            };

            this.hubs = hubs.map(callback)
          })
          .catch(logout)
      );
    },
    classesCssItemDataTable(linha) {
      return {
        'text-red': linha.status === 'FL'
      };
    },
    limparFiltrosFilial() {
      this.filtros_filias.filiais_origem = [];
      this.filtros_filias.filiais_destino = [];
    }
  },
};
</script>

